var path = 'app/scripts/modules/core/src/projects/dashboard/cluster/projectClusterRefresh.tooltip.html';
var html = "<p ng-if=\"vm.state.refreshing\">Cluster data is <strong>refreshing</strong></p>\n<p ng-if=\"!vm.state.refreshing\">(click <span class=\"fa fa-refresh\"></span> to refresh)</p>\n<p>Last refresh: {{vm.state.lastRefresh | timestamp }} <br> ({{vm.state.lastRefresh | relativeTime }})</p>\n<p class=\"small\"><strong>Note:</strong> Due to caching, data may be delayed up to 2 minutes</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/projects/dashboard/cluster/projectClusterRefresh.tooltip.html
// module id = 1114
// module chunks = 0